exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-dialog-buttongroup {\n  border-style: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/buttons/spro-dialog-button/spro-dialog-button.component.scss
// module id = ../../../../../src/app/sproLib/spro/buttons/spro-dialog-button/spro-dialog-button.component.scss
// module chunks = main